import React, {FC} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../libs/shared/helpers/src/internationalization/react';
import {HandlerOf} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {DropdownBoxCoordinator} from '../../../../../libs/shared/ui/src/components/boxedInputs/dropdownBoxCoordinator';
import {SimpleDropdown} from '../../../../../libs/shared/ui/src/components/dropdowns/simpleDropdown';
import {SimpleDropdownItem} from '../../../../../libs/shared/ui/src/components/dropdowns/simpleDropdownItem';
import {PopoverTransferProps} from '../../../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {useUserTheme} from '../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {Text} from '../../../common/text/text';

export enum EditModesEnum {
  VISUAL = 'VISUAL',
  HTML = 'HTML',
}

export interface EditModeDropdownProps {
  selectedMode: EditModesEnum;
  setSelectedMode: HandlerOf<EditModesEnum>;
}

const StyledDropdownContainerDiv = styled.div`
  display: flex;
  align-items: center;
`;

const StyledDropdownLabelWrapper = styled.div`
  margin-right: 8px;
`;

function renderDropdown(
  popoverProps: PopoverTransferProps,
  selectedMode: EditModesEnum,
  setEditMode: HandlerOf<EditModesEnum>,
) {
  return (
    <SimpleDropdown {...popoverProps}>
      <SimpleDropdownItem
        onSelect={() => setEditMode(EditModesEnum.VISUAL)}
        isChecked={EditModesEnum.VISUAL === selectedMode}
      >
        <Trans id="settings-composer-visual-mode-item">Visual mode</Trans>
      </SimpleDropdownItem>
      <SimpleDropdownItem
        onSelect={() => setEditMode(EditModesEnum.HTML)}
        isChecked={EditModesEnum.HTML === selectedMode}
      >
        <Trans id="settings-composer-html-mode-item">HTML mode</Trans>
      </SimpleDropdownItem>
    </SimpleDropdown>
  );
}

function getValue(mode: EditModesEnum) {
  if (mode === EditModesEnum.VISUAL) {
    return <Trans id="settings-composer-visual-mode-selected-item">Visual Mode</Trans>;
  }
  if (mode === EditModesEnum.HTML) {
    return <Trans id="settings-composer-html-mode-selected-item">HTML Mode</Trans>;
  }
  return '';
}

export const EditModeDropdown: FC<EditModeDropdownProps> = (props) => {
  const theme = useUserTheme();
  const {selectedMode, setSelectedMode} = props;
  return (
    <StyledDropdownContainerDiv>
      <StyledDropdownLabelWrapper>
        <Text color={theme.greys.shade70}>
          <Trans id="settings-composer-edit-mode-dropdown-label">Edit using: </Trans>
        </Text>
      </StyledDropdownLabelWrapper>

      <DropdownBoxCoordinator
        value={getValue(selectedMode)}
        renderDropdown={(popoverProps) => renderDropdown(popoverProps, selectedMode, setSelectedMode)}
        shouldDisablePadding
      />
    </StyledDropdownContainerDiv>
  );
};
